import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../../../../components/shared/button/Button';

interface ScheduleUpdateAlertProps {
  employeeId: string;
  requestId?: string;
  message: string;
  warning?: boolean;
}

export const ScheduleUpdateAlert: FC<ScheduleUpdateAlertProps> = ({
  employeeId,
  requestId,
  message,
  warning = true
}) => {
  const navigate = useNavigate();
  const styling = warning
    ? 'border-yellow-300 bg-yellow-50 text-yellow-900'
    : 'border-green-300 bg-green-100 text-green-900';

  const destination = requestId
    ? `/team-member/${employeeId}/schedule-update/${requestId}`
    : `/team-member/${employeeId}/schedule-updates`;

  return (
    <div className={`mb-4 rounded-lg border p-5 ${styling}`}>
      <div className="flex items-center justify-between gap-4">
        <p className="font-semibold">{message}</p>
        <Button onClick={() => navigate(destination)}>View</Button>
      </div>
    </div>
  );
};
